import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';

/** Compact segmented control (e.g. List / Map). */
const SegmentedToggle = ({ options, value, onChange }) => (
  <Styled.Group role="tablist">
    {options.map((opt) => {
      const Icon = opt.icon;
      return (
        <Styled.Item
          key={opt.key}
          type="button"
          role="tab"
          aria-selected={value === opt.key}
          active={value === opt.key}
          onClick={() => onChange(opt.key)}
        >
          {Icon && <Icon />}
          {opt.label}
        </Styled.Item>
      );
    })}
  </Styled.Group>
);

SegmentedToggle.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.elementType,
    }),
  ).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SegmentedToggle;
